import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ContactInfo from './ContactInfo';
import { Helmet } from 'react-helmet-async';
import InsuranceSection from './InsuranceSection';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function BedriftPage() {
  const [content, setContent] = useState({});

  useEffect(() => {
    axios.get(`${API_URL}/api/content/bedrift`).then(res => {
      const organized = res.data.reduce((acc, item) => ({ ...acc, [item.element_id]: item }), {});
      setContent(organized);
    });
  }, []);

  const viVetAtList = content.bedrift_boks1_tekst?.value.split('|') || [];
  const senkSykefraværList = content.bedrift_boks2_tekst?.value.split('|') || [];

  return (
    <div>
      <Helmet>
      <title>Bedriftsavtale Naprapat – Sunnfjord Naprapatsenter</title>
      <meta name="description" content="Reduser sykefraværet og øk trivselen med en bedriftsavtale. Vi tilbyr naprapatbehandling og ergonomisk veiledning for bedrifter i Sunnfjord." />
    </Helmet>
      <section className="bedrift-intro-section">
        <h1>{content.bedrift_tittel?.value}</h1>
        <p className="intro-paragraph">{content.bedrift_intro_p1?.value}</p>
        <p className="intro-paragraph">{content.bedrift_intro_p2?.value}</p>
      </section>

      {/* --- NY, TO-KOLONNERS SEKSJON --- */}
      <section className="page-section two-column-section">
        <div className="text-column">
          <div className="card info-box-static">
            <h3>{content.bedrift_visste_du_at_tittel?.value}</h3>
            <ul className="info-box-list">
              {viVetAtList.map((item, index) => <li key={index}>{item}</li>)}
            </ul>
          </div>
        </div>
        <div className="image-column">
          <img src={content.bedrift_visste_du_at_bilde?.value} alt="Naprapatbehandling for bedrifter" />
        </div>
      </section>

      <section className="page-section bedrift-boxes-section">
        <div className="card info-box-static">
          <h3>{content.bedrift_boks1_tittel?.value}</h3>
          <ul className="info-box-list">
            {viVetAtList.map((item, index) => <li key={index}>{item}</li>)}
          </ul>
        </div>
        <div className="card info-box-static">
          <h3>{content.bedrift_boks2_tittel?.value}</h3>
          <ul className="info-box-list">
            {senkSykefraværList.map((item, index) => <li key={index}>{item}</li>)}
          </ul>
        </div>
        
        {/* --- VIKTIG: Bytter ut den gamle boksen med den nye komponenten --- */}
        <InsuranceSection />
      </section>

      <section className="page-section bedrift-contact-section">
        <ContactInfo />
      </section>
    </div>
  );
}

export default BedriftPage;